/**
 * 获取URL地址中的指定键值
 * @name getQuery
 * @function
 * @grammar getQuery( key[ , url] )
 * @param {string} key 指定的键名
 * @param {string} [url] 目标URL地址，如果为空，则为当前页面URL地址
 *
 * @return {String|Array} URL中指定键名对应的值，如果为多个，则返回数组
 */
export const getQuery = function(key, url) {
  // eslint-disable-next-line prefer-template
  url = url || window.location.href + '';
  if (url.indexOf('#') !== -1) url = url.substring(0, url.indexOf('#'));
  // eslint-disable-next-line one-var,vars-on-top,no-var
  var rts = [],
    rt;
  // eslint-disable-next-line prefer-template,vars-on-top,no-var
  var queryReg = new RegExp('(^|\\?|&)' + key + '=([^&]*)(?=&|#|$)', 'g');
  // eslint-disable-next-line no-cond-assign
  while ((rt = queryReg.exec(url)) !== null) {
    rts.push(decodeURIComponent(rt[2]));
  }
  if (rts.length === 0) return null;
  if (rts.length === 1) return rts[0];
  return rts;
}

/**
 * 参数序列化URI
 * NOTE：url自身带参数等特殊情况没有做兼容
 * @param {*} url 
 * @param {*} obj 
 */
export const stringify = (url, obj) => {
  if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
    const str = Object.keys(obj).map(key => {
      if (Array.isArray(obj[key])) {
        return obj[key].map(value => `${key}=${value}`).join('&');
      }
      return `${key}=${obj[key]}`;
    }).join('&');
    return url 
      ? `${url}${url.indexOf('?') > 0 ? '&' : '?'}${str || ''}`
      : str;
  }
  return url;
};
